import { Injectable, inject } from '@angular/core';
import {
    UserPositionDto,
    UserPositionExitCleanupTask,
} from '@pf/platform-core/domain';
import { EquipmentDataService } from '@pf/platform-wms/domain';
import { asArraySafe } from '@pf/shared-utility';
import { Observable, of } from 'rxjs';
import { HandlingUnitsContext } from '../../models/handling-units-context.model';

type HandlingUnitsContextWithWarehouse = HandlingUnitsContext & {
    warehouseId?: string;
};

@Injectable({ providedIn: 'root' })
export class EquipmentPositionExitCleanupTask
    implements UserPositionExitCleanupTask
{
    readonly id = 'equipment-release-handling-units';

    private readonly equipmentDataService = inject(EquipmentDataService);

    appliesTo(position: UserPositionDto): boolean {
        const ctx = position.context as
            | HandlingUnitsContextWithWarehouse
            | undefined;
        return (
            !!asArraySafe(ctx?.assignedHandlingUnitIds).length &&
            !!ctx?.warehouseId &&
            !!position.userId
        );
    }

    cleanup$(position: UserPositionDto): Observable<unknown> {
        const ctx = position.context as
            | HandlingUnitsContextWithWarehouse
            | undefined;
        const warehouseId = ctx?.warehouseId;
        const equipmentIds = asArraySafe(ctx?.assignedHandlingUnitIds);
        const userId = position.userId;
        if (!warehouseId || !userId || !equipmentIds.length) return of(null);
        return this.equipmentDataService.releaseForUser$(
            warehouseId,
            userId,
            equipmentIds
        );
    }
}
